import { observer } from 'mobx-react-lite'
import ArpRegistry from '../../../../features/arp-registry/ArpRegistry'
import { useTreeState } from '../../../stores/Root'
import { InputContainerButton } from './common'
import { TEMPO_RANGE } from './Tempo'

const useTapToTempo = () => {
  const { studio } = useTreeState()
  const disabled = !ArpRegistry.readyForStudioUse

  // stolen from here: https://www.nayuki.io/res/tap-to-measure-tempo-javascript/tap-to-measure-tempo.js
  // performs simple linear regression to get the tempo from the taps
  var beatTimes: number[] = []
  var xSum = 0
  var xxSum = 0
  var ySum = 0
  var yySum = 0
  var xySum = 0

  const collectTaps = () => {
    // If the last tap was more than 2.5 seconds ago, clear the array
    if (
      beatTimes.length > 0 &&
      Math.abs(Date.now() - beatTimes[beatTimes.length - 1]) / 1000 >= 3.5
    ) {
      beatTimes = []
    }
    // Add beat
    beatTimes.push(Date.now())
    var n = beatTimes.length

    // Coordinates for linear regression
    var x = n - 1
    var y = beatTimes[n - 1] - beatTimes[0]

    // Regression cumulative variables
    xSum += x
    xxSum += x * x
    ySum += y
    yySum += y * y
    xySum += x * y

    var tempo = (60000 * x) / y
    if (n >= 2) {
      const newTempo = Math.floor(tempo)
      const newTempoInRange = Math.max(Math.min(newTempo, TEMPO_RANGE[1]), TEMPO_RANGE[0])
      studio.song.updateTempo(newTempoInRange)
    }
  }

  return { collectTaps, disabled }
}

const TapToTempo = () => {
  const { collectTaps, disabled } = useTapToTempo()
  return (
    <InputContainerButton
      onClick={() => collectTaps()}
      tooltipText="Tap to Tempo"
      disabled={disabled}
    >
      Tap
    </InputContainerButton>
  )
}

export default observer(TapToTempo)
